/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To make ${i?.vol} mL of ${i?.name}:`)
};

const es_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para preparar ${i?.vol} mL de ${i?.name}:`)
};

const de_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für ${i?.vol} mL ${i?.name} benötigen Sie:`)
};

const nl_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Om ${i?.vol} mL ${i?.name} te maken:`)
};

const fr_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pour préparer ${i?.vol} mL de ${i?.name} :`)
};

const it_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Per preparare ${i?.vol} mL di ${i?.name}:`)
};

const pt_br2_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para preparar ${i?.vol} mL de ${i?.name}:`)
};

const pt_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para preparar ${i?.vol} mL de ${i?.name}:`)
};

const ja_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}を${i?.vol} mL調製するには:`)
};

const zh_buf_to_make = /** @type {(inputs: { vol: NonNullable<unknown>, name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`配制 ${i?.vol} mL 的 ${i?.name}：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ vol: NonNullable<unknown>, name: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_to_make = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_to_make(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_to_make", locale)
	if (locale === "en") return en_buf_to_make(inputs)
	if (locale === "es") return es_buf_to_make(inputs)
	if (locale === "de") return de_buf_to_make(inputs)
	if (locale === "nl") return nl_buf_to_make(inputs)
	if (locale === "fr") return fr_buf_to_make(inputs)
	if (locale === "it") return it_buf_to_make(inputs)
	if (locale === "pt-BR") return pt_br2_buf_to_make(inputs)
	if (locale === "pt") return pt_buf_to_make(inputs)
	if (locale === "ja") return ja_buf_to_make(inputs)
	return zh_buf_to_make(inputs)
};